import active from "../../../../env-vars.json";

export const MAIN_NODES_X_OFFSET = 600;
export const MAIN_NODES_SIZE = 150;
export const CHILD_NODES_SIZE = 150;
export const APP_VERSION = `v${active.version_production}`;
